import { restRequest } from "vrcore-dashboard/dist/utilities";

const types = assignmentType => {
    return {
        GET_ALL_FILE_MANAGER_FILES: restRequest(
            `VRCORE.JOB_PACK_WIDGETS.${assignmentType}.GET_ALL_FILE_MANAGER_FILES`
        ),
        GET_FOLDERS: restRequest(
            `VRCORE.JOB_PACK_WIDGETS.${assignmentType}.GET_FOLDERS`
        ),
        UPLOAD_FILE: restRequest(
            `VRCORE.JOB_PACK_WIDGETS.${assignmentType}.UPLOAD_FILE`
        ),
        SET_FILE_TYPE: `VRCORE.JOB_PACK_WIDGETS.${assignmentType}.SET_FILE_TYPE`
    };
};

export default types;
